import { Component, Input, inject } from '@angular/core';
import { OffcanvasService } from '../../../../_services/offcanvas-service/offcanvas.service';
import { HttpParams } from '@angular/common/http';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-offcanvas-cancel-btn',
  standalone: true,
  template: `
    <div
      class="mb-0"
      ngbTooltip="Waiting for background tasks to complete"
      [disableTooltip]="!isDisabled">
      <button
        id="offcanvasCancelBtn"
        type="button"
        [disabled]="isDisabled"
        (click)="close()"
        class="btn btn-outline-dark">
        {{ btnText }}
      </button>
    </div>
  `,
  imports: [NgbTooltip],
})
export class OffcanvasCancelBtnComponent {
  readonly offcanvasService = inject(OffcanvasService);

  @Input() returnUrl: string | undefined;
  @Input() returnParams: HttpParams | undefined;
  @Input() btnText: string = 'Cancel';
  @Input() isDisabled: boolean = false;

  close() {
    if (this.returnUrl) {
      this.offcanvasService.close(this.returnUrl, this.returnParams);
    }
  }
}
